module.exports = __webpack_public_path__ + "assets/bcf4e02c91f2329be1b31133ee8b51c5.png";